<script>
    import Typography from '../UI/Typography.svelte'
    import { ChevronBackOutline } from '../Icons'
    export let title = ''
    import { createEventDispatcher } from 'svelte'
    const dispatcher = createEventDispatcher()
    function onBack() {
        dispatcher('back')
    }
</script>

<div class="mainContainer">
    <div class="bar">
        <span
            style="cursor: pointer; display: flex; gap: 35px"
            on:click={onBack}
        >
            <ChevronBackOutline size={24} color="white" />
            <Typography color="white" type="h4" style="margin: 0; padding: 0"
                >{title}</Typography
            >
        </span>
        <slot name="bar" />
    </div>
    <div class="container">
        <slot />
    </div>
</div>

<style>
    .mainContainer,
    .container {
        width: 100%;
        height: 100%;
        min-height: 70px;
        display: flex;
        position: relative;
    }
    .mainContainer {
        flex-direction: column;
    }
    .bar {
        width: 100%;
        height: 70px;
        display: flex;
        position: relative;
        flex-direction: row;
        justify-content: space-between;
        padding: 0 0 0 70px;
        background-color: var(--color-brand-primary-01);
        align-items: center;
        gap: 26px;
    }
    .container {
        justify-content: center;
        align-items: center;
    }
</style>
